import request from '@/api/request.js'

// 验证
export function SystemCdKeyVerify(data) {
    return request({
        url: '/api/cdkey/systemcdkeyverify',
        method: 'post',
        data: data
    })
}

// 新增
export function SystemCdKeyInsert(data) {
    return request({
        url: '/api/cdkey/systemcdkeyinsert',
        method: 'post',
        data: data
    })
}

// 删除
export function SystemCdKeyDelete(id) {
    return request({
        url: `/api/cdkey/systemcdkeydelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function SystemCdKeyUpdate(id, data) {
    return request({
        url: `/api/cdkey/systemcdkeyupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function SystemCdKeyGetById(id) {
    return request({
        url: `/api/cdkey/getsystemcdkeybyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function SystemCdKeyGetList(params) {
    return request({
        url: '/api/cdkey/getsystemcdkeylist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function SystemCdKeyGetPageList(params) {
    return request({
        url: '/api/cdkey/getsystemcdkeypagelist',
        method: 'get',
        params: params
    })
}